// Ayudas de la pantalla de la integración API Nemesis (casos de cobranza): URL del webhook, token y
// los grupos de campos opcionales del formulario (ver Webhooks::NemesisController).

export const NEMESIS_WEBHOOK_PATH = '/webhooks/nemesis/casos';

export const generateNemesisToken = () => {
  const bytes = new Uint8Array(32);
  window.crypto.getRandomValues(bytes);
  return Array.from(bytes, byte => byte.toString(16).padStart(2, '0')).join('');
};

// El formulario arranca solo con lo indispensable (nombre, token, bandeja y plantilla). Todo lo
// demás son grupos de campos que se suman con un botón. Cada campo conserva su valor por defecto
// (apps.yml) aunque su grupo esté cerrado: cerrar o no abrir un grupo no deja la integración sin
// configurar, usa los valores estándar.
// - `i18n`: clave dentro de INTEGRATION_APPS.NEMESIS.OPTIONAL (título, descripción y ayuda).
// - `section`: en qué bloque de la lista de opciones se muestra (WHO / DATA / CHECKS).
// - `icon`: ícono de la tarjeta. `recommended`: se marca como recomendado.
export const NEMESIS_OPTION_SECTIONS = ['WHO', 'DATA', 'CHECKS'];

export const NEMESIS_OPTIONAL_GROUPS = [
  {
    id: 'team',
    i18n: 'TEAM',
    section: 'WHO',
    icon: 'i-lucide-users',
    recommended: true,
    fields: ['assigned_team_id'],
  },
  {
    id: 'agent',
    i18n: 'AGENT',
    section: 'WHO',
    icon: 'i-lucide-user',
    fields: ['assigned_agent_id'],
  },
  {
    id: 'caseAgent',
    i18n: 'CASE_AGENT',
    section: 'WHO',
    icon: 'i-lucide-user-check',
    fields: ['map_agent'],
  },
  {
    id: 'bodyFields',
    i18n: 'BODY_FIELDS',
    section: 'DATA',
    icon: 'i-lucide-braces',
    fields: ['map_name', 'map_surname', 'map_cuil', 'map_link', 'map_phone'],
  },
  {
    id: 'caseId',
    i18n: 'CASE_ID',
    section: 'DATA',
    icon: 'i-lucide-hash',
    fields: ['map_case_id'],
  },
  {
    id: 'linkHosts',
    i18n: 'LINK_HOSTS',
    section: 'CHECKS',
    icon: 'i-lucide-shield-check',
    fields: ['link_allowed_hosts'],
  },
  {
    id: 'language',
    i18n: 'LANGUAGE',
    section: 'CHECKS',
    icon: 'i-lucide-languages',
    fields: ['template_language'],
  },
];

export const nemesisGroupOfField = fieldName =>
  NEMESIS_OPTIONAL_GROUPS.find(group => group.fields.includes(fieldName));

const isBlank = value => value === undefined || value === null || value === '';

// Campos que el servidor completa solo cuando vienen vacíos (idioma es_AR, dominios de Mercado
// Pago): vacío equivale a lo estándar. En cambio un ID del caso vacío es una decisión (no usar
// ID), no lo estándar.
const BLANK_MEANS_STANDARD = ['template_language', 'link_allowed_hosts'];

// Valor al que vuelve un campo cuando se quita su grupo: el por defecto de apps.yml y, si no tiene,
// vacío (null en los selectores, para que al guardar quede explícitamente sin elegir).
export const nemesisFieldReset = item => {
  if (item.default !== undefined) return item.default;
  return item.type === 'select' ? null : '';
};

// Grupos que ya tienen algo distinto de lo estándar (para abrirlos solos al editar una integración).
export const nemesisCustomizedGroups = (values = {}, formItems = []) =>
  NEMESIS_OPTIONAL_GROUPS.filter(group =>
    group.fields.some(name => {
      const item = formItems.find(candidate => candidate.name === name);
      const standard = item?.default;
      const current = values[name];
      if (isBlank(current) && isBlank(standard)) return false;
      if (isBlank(current) && BLANK_MEANS_STANDARD.includes(name)) return false;
      return String(current ?? '').trim() !== String(standard ?? '').trim();
    })
  ).map(group => group.id);
